(function () {
  const Shop = {
    init: function () {
      this.eventListenersInit();
      this.mobileFilter();
      this.onIgReady();
    },

    eventListenersInit() {
      const categoriesPopup = document.getElementById('categories-popup');
      const categoriesPopupContent = document.getElementById('categories-popup-content');

      document.getElementById('filter-btn').addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          categoriesPopup.classList.add('categories-popup--opened');
          categoriesPopupContent.classList.remove('slideOutLeft');
          categoriesPopupContent.classList.add('slideInLeft');
        }
      );

      document.getElementById('popup-closer').addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          categoriesPopupContent.classList.add('slideOutLeft');
          categoriesPopupContent.classList.remove('slideInLeft');
          categoriesPopup.classList.remove('categories-popup--opened');
        }
      );
    },

    mobileFilter() {
      document.getElementById('show-filter-results').addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          const categoriesSelected = document.querySelectorAll('.categories-popup__list input:checked');

          if (categoriesSelected.length > 0) {
            const categoryId = categoriesSelected[0].id;
            let url = '/collections';
            if (categoryId !== 'shopAll') {
              url = `${url}/${categoryId}`;
            }

            window.location.replace(url);
          }
        }
      );

      document.getElementById('clear-mobile-filter').addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          const categoriesSelected = document.querySelectorAll('.categories-popup__list input:checked');
          if (categoriesSelected.length > 0) {
            categoriesSelected[0].checked = false;
          }
        }
      );
    },

    onIgReady() {
      console.log('onIgReady');
      document.querySelectorAll('.grid-product').forEach(/** @param {HTMLDivElement} selectorEl */function (selectorEl) {
        const basePrice = window.igData?.price.getComparePriceByVariantId(selectorEl.dataset.variantId)
        || selectorEl.dataset.basePrice; 
        const itemBasePrice = basePrice * selectorEl.dataset.canonicalQuantity;
        selectorEl.dataset.basePrice = itemBasePrice;
        const itemBulkDiscountedPrice = window.igData?.price.getPriceByVariantId(selectorEl.dataset.variantId)
          || selectorEl.dataset.bulkPrice;
        if (!itemBulkDiscountedPrice) {
          return;
        }
        selectorEl.dataset.bulkPrice = itemBulkDiscountedPrice;
        const fullyDiscountedPrice = itemBulkDiscountedPrice
          - (itemBulkDiscountedPrice * selectorEl.dataset.subDiscountPercentage / 100);
        const discountAmount = itemBasePrice - (fullyDiscountedPrice * selectorEl.dataset.canonicalQuantity);
        const discountPercentage = discountAmount * 100 / itemBasePrice;
        selectorEl.dataset.discountPercentage = discountPercentage;
        selectorEl.querySelector('.grid-product__tag--custom span').innerText = 'Up to ' + Math.round(discountPercentage) + '% Off';
      });      
    }
  };

  window.addEventListener('load', (event) => {
    Shop.init();
  });

})();
